import { Link } from "react-router-dom";
import { CiftoraLogo } from "@/lib/brand";
import { useSeo } from "@/lib/seo";

const btn = "inline-flex h-12 items-center rounded-full px-6 text-sm font-bold";

export default function NotFound() {
  useSeo({
    title: "Sayfa bulunamadı",
    description: "Aradığınız sayfa bulunamadı. Ciftora ana sayfasına dönebilir veya ilanları inceleyebilirsiniz.",
    noindex: true,
  });

  return (
    <div className="mx-auto max-w-xl px-4 py-20 text-center" data-testid="not-found-page">
      <CiftoraLogo variant="primary" className="mx-auto h-14" testid="not-found-logo" />
      <p className="mt-10 font-display text-6xl font-extrabold text-accent">404</p>
      <h1 className="mt-4 font-display text-2xl font-extrabold text-primary sm:text-3xl">
        Aradığınız sayfa bulunamadı.
      </h1>
      <p className="mt-3 text-sm text-muted-foreground">
        Bağlantı taşınmış veya süresi geçmiş olabilir. Aşağıdan devam edebilirsiniz.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" data-testid="not-found-home-btn" className={`${btn} bg-primary text-primary-foreground`}>
          Ana Sayfa
        </Link>
        <Link to="/ilanlar" data-testid="not-found-listings-btn" className={`${btn} bg-secondary text-secondary-foreground`}>
          İlanları Gör
        </Link>
      </div>
    </div>
  );
}
